import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/AuthLayout';
import AppLayout from './layouts/AppLayout';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Templates from './pages/templates/Templates';
import TemplateCreate from './pages/templates/TemplateCreate';
import TemplateEdit from './pages/templates/TemplateEdit';
import TemplateCategories from './pages/templates/TemplateCategories';
import Tools from './pages/tools/Tools';
import ToolsSettings from './pages/tools/ToolsSettings';
import Content from './pages/content/Content';
import Media from './pages/content/Media';

export default function App() {
  return (
    <Routes>
      {/* Auth plate: login & forgot password — guarded by GuestOnly; no sidebar */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      {/* App plate: header + sidebar + content — guarded by RequireAuth */}
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/new" element={<TemplateCreate />} />
        <Route path="/templates/:id/edit" element={<TemplateEdit />} />
        <Route path="/templates/categories" element={<TemplateCategories />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/tools/settings" element={<ToolsSettings />} />
        <Route path="/content" element={<Content />} />
        <Route path="/content/media" element={<Media />} />
      </Route>

      {/* Default: send to app or login based on auth (handled by layout guards) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
